import { useState } from 'react';
import { Container, BtnGeneration, Load } from './styled';
import { IoClose } from "react-icons/io5";
import { answerGenerationAi } from '../../service/serviceChat/copilot4uService';

export function AnswerGeneration(props) {

    const { onClose, messages, onResponse } = props;
    const [inProgress, setInProgress] = useState(false);

    const joinMessages = (messages) => {
        let message = '';
        messages.forEach(obj => {
            const addMessage = obj[Object.keys(obj)[0]];
            message += addMessage + ' ';
        });
        return message
    };
    async function generation(messages) {
        setInProgress(true);
        const { data } = await answerGenerationAi(
            joinMessages(messages)
        );
        onResponse(data)
        setInProgress(false)
        onClose();
    };


    return (
        <Container>
            <div>
                {!inProgress && (
                    <IoClose
                        className='icTs'
                        onClick={() => onClose()}
                    />)
                }
                <span>
                    {!inProgress
                        ? (` ${messages?.length} selecionadas`)
                        : (`Gerando respostas ...`)
                    }
                </span>
            </div>
            <div>
                <BtnGeneration
                    disabled={(messages.length < 1 || inProgress) ? true : false}
                    onClick={() => { generation(messages) }}
                >
                    {!inProgress
                        ? (<>{`Gerar resposta`}</>)
                        : (<Load>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </Load>)
                    }
                </BtnGeneration>
            </div>
        </Container>
    );
}